

export const loadOpenCV = (full=false)=>{
    self.cv = require(`../includes/opencv${full ? "-full" : ""}.js`);
}

export const usleep = (ms=1000) => new Promise<void>(resolve => self.setTimeout(() => resolve(), ms))